//! @/script/filter.js

function initFilter() {
  $(".block-search").each(function () {
    var $input = $(this).find("input[name='search']"),
      $button = $(this).find("button"),
      $search = $(this).find(".form-search__search");

    let jXHR = null;
    let search = "";

    var preSearch = debounce(() => {
      if (jXHR !== null) {
        jXHR.abort();
      }

      if (search === $input.val()) {
        return;
      }

      $search.empty();
      $search.hide();
      search = $input.val();

      if (search.length < 3) {
        return;
      }

      jXHR = $.post("index.php?route=rmx/filter/search", { search })
        .done(({ categories, products }) => {
          if (products.length) {
            $search.show();
          }

          categories.forEach((item) => {
            $search.append(
              $("<a />", {
                class: "underline",
                href: item.href,
                text: item.name,
              })
            );
          });

          if (categories.length) {
            $search.append(
              $("<span/>", {
                class: "form-search__delimiter",
              })
            );
          }

          products.forEach((item) => {
            $search.append(
              $("<a />", {
                href: item.href,
                text: item.name,
              })
            );
          });
        })
        .always(() => (jXHR = null));
    }, 500);

    $button.on("click", function () {
      // var url = $("base").attr("href") + "index.php?route=product/search";
      var value = $input.val();

      if (value) {
        // url += "&search=" + encodeURIComponent(value);
        location = "/search/?search=" + encodeURIComponent(value);
      }

      // location = url;
    });

    $input.on("keyup", function (e) {
      if (e.keyCode == 13) {
        $button.click();
      } else {
        preSearch();
      }
    });
  });

  if (document.getElementById("form-filter") == null) return;

  $(".block-filter-item__header").on("click", function () {
    $(this).parent().addClass("active");
    $(this)
      .parent()
      .find(".block-filter-wrapper")
      .slideToggle(500, function () {
        $(this).parent().toggleClass("open");
        $(this).parent().removeClass("active");
      });
  });

  // При загрузке страницы выбрать отмеченные чекбоксы
  $(".block-filter-item, label.checkbox")
    .find('input[type="checkbox"]:checked')
    .each(function () {
      $(this).closest("label").addClass("checked");
    });

  // Чекбоксы
  $('.block-filter-item input[type="checkbox"]').on("click", function () {
    if (!$(this).prop("checked")) {
      $(this).closest("label").removeClass("checked");
      return;
    }

    $(this).closest("label").addClass("checked");
  });

  $('#form-filter .block-filter-item input[type="checkbox"]').on(
    "change",
    function () {
      prefilterDelay($(this).closest("label"));
    }
  );

  // SLIDER
  var min = priceToInt($("#filter-min").data("min"));
  var max = priceToInt($("#filter-max").data("max"));
  var minValue = priceToInt($("#filter-min").val());
  var maxValue = priceToInt($("#filter-max").val());

  $("#filter-price-slider").slider({
    min: min,
    max: max,
    values: [minValue, maxValue],
    range: true,
    stop: function (event, ui) {
      $("input#filter-min").val(
        intToPrice($("#filter-price-slider").slider("values", 0))
      );
      $("input#filter-max").val(
        intToPrice($("#filter-price-slider").slider("values", 1))
      );

      prefilterDelay($("#filter-price-slider"));
    },
    slide: function (event, ui) {
      $("input#filter-min").val(
        intToPrice($("#filter-price-slider").slider("values", 0))
      );
      $("input#filter-max").val(
        intToPrice($("#filter-price-slider").slider("values", 1))
      );
    },
    create: function (event, ui) {
      $("input#filter-min").val(
        intToPrice($("#filter-price-slider").slider("values", 0))
      );
      $("input#filter-max").val(
        intToPrice($("#filter-price-slider").slider("values", 1))
      );
    },
  });

  $("#filter-price input").on("keyup", function (event) {
    $(this).addClass("changed");

    var value1 = priceToInt($("input#filter-min").val());
    var value2 = priceToInt($("input#filter-max").val());

    if (isNaN(value1) || value1 < min) value1 = min;
    if (isNaN(value2) || value2 > max) value2 = max;

    switch ($(this).attr("id")) {
      case "filter-min":
        if (value1 > value2) value1 = value2;
        break;

      default:
        if (value1 > value2) value2 = value1;
        break;
    }

    $("#filter-price-slider").slider("values", 0, value1);
    $("#filter-price-slider").slider("values", 1, value2);

    if (event.keyCode != 13) return;

    $(this).focusout();
  });

  $("#filter-price input").on("focusout", function (event) {
    console.log(
      $("#filter-price-slider").slider("values", 0),
      $("#filter-price-slider").slider("values", 1)
    );

    $("input#filter-min").val(
      intToPrice($("#filter-price-slider").slider("values", 0))
    );
    $("input#filter-max").val(
      intToPrice($("#filter-price-slider").slider("values", 1))
    );

    if ($(this).hasClass("changed")) {
      prefilterDelay(this);
      $(this).removeClass("changed");
    }
  });
}

function priceToInt(value) {
  return parseInt(String(value).replace(/\s+/g, ""));
}

function intToPrice(value) {
  return String(value).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ") + " ₽";
}

function prefilter(el) {
  let params = $("#form-filter").serializeArray();
  params.forEach(function (item, key) {
    if (item.name == "min" || item.name == "max") {
      params[key]["value"] = priceToInt(item.value);
    }
  });

  let jqXHR = $.get("/index.php?route=rmx/filter/pre", params);
  jqXHR.done(function (response) {
    let names = ["товар", "товара", "товаров"];
    let $button = $("#filter-search-button");
    let $el = $(el);
    let pos =
      $el.position().top +
      $el.outerHeight(true) / 2 -
      $button.outerHeight(true) / 2;

    $button
      .html(
        "Показать " +
          response["count"] +
          " " +
          declension(response["count"], names)
      )
      .show()
      .css("top", pos);
  });
}

var searchTimeout = 0;

// Поиск с задержкой
function prefilterDelay(el) {
  var delay = 500;

  clearTimeout(searchTimeout);
  searchTimeout = setTimeout(function () {
    prefilter(el);
  }, delay);
}

// Склонение окончаний
function declension(num, expressions) {
  let result;
  let count = num % 100;

  if (count >= 5 && count <= 20) {
    result = expressions["2"];
  } else {
    count = count % 10;
    if (count == 1) {
      result = expressions["0"];
    } else if (count >= 2 && count <= 4) {
      result = expressions["1"];
    } else {
      result = expressions["2"];
    }
  }
  return result;
}

function submitFilter() {
  let url = document.createElement("a");
  url.href = window.location.href;

  let params = getParams(window.location.href);
  params = filterParams(params);

  let def = {
    sort: "pd.name",
    order: "ASC",
    min: document.getElementById("filter-min").getAttribute("data-min"),
    max: document.getElementById("filter-max").getAttribute("data-max"),
  };

  let data = new FormData(document.getElementById("form-filter"));

  data.forEach(function (value, key) {
    switch (key) {
      case "min":
      case "max":
        value = priceToInt(value);
        break;
    }

    if (value == "") return;
    if (key in def && value == def[key]) return;

    params.push({
      name: key,
      value: value,
    });
  });

  url.search = buildQueryString(params);

  window.location.href = url.href;
}

var getParams = function (url) {
  let params = [];

  let parser = document.createElement("a");
  parser.href = url;

  let query = parser.search.substring(1);
  let vars = query.split("&");

  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");

    params.push({
      name: pair[0],
      value: decodeURIComponent(pair[1]),
    });
  }

  return params;
};

var filterParams = function (params) {
  // let filter = ['route', 'path', 'sort', 'order', 'limit', 'search', 'category_id'];
  let filter = ["route", "path", "sort", "order", "limit", "category_id"];
  let result = [];

  for (let i of params) {
    if (filter.includes(i.name)) {
      result.push(i);
    }
  }

  return result;
};

function buildQueryString(params) {
  let esc = encodeURIComponent;
  let query = params
    .map(function (i) {
      return esc(i.name) + "=" + esc(i.value);
    })
    .join("&");

  return query;
}
